import { Grid } from "@mui/material";
import React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { GridRow } from "../../../../framework/Grid/GridRow";
import { Translations } from "ui/Scripts/source/models/translations";
import { TaskTypeClassWidthPrefix } from "ui/Scripts/source/models/enums";
import { TaskTypeDialogPreviewType } from "../TaskTypeDialogPreviewWeb";
import { ILineColumnWidth } from "../../TaskTypeDialogFormDesigner/FormDesignerComponentProperties/FormDesignerComponentPropertiesRow";
import { FormDesignerComponentPropertiesWidth } from "../../TaskTypeDialogFormDesigner/FormDesignerComponentProperties/FormDesignerComponentPropertiesWidth";
import { FormAccordion } from "source/components/framework/FormAccordion";

interface ITaskTypeDialogPreviewComponentPropertiesRowProps {
    previewType: TaskTypeDialogPreviewType;
    lineTypeCol: ITaskTypeCol;
    lineColumnWidths: ILineColumnWidth[];
    formFieldMargin: string;
    onChangeLineColumnWidth: (id: string, classes: string) => void;
}

export const TaskTypeDialogPreviewComponentPropertiesRow = (
    props: ITaskTypeDialogPreviewComponentPropertiesRowProps
) => {
    if (!props.lineTypeCol) return null;
    return (
        <FormAccordion
            defaultExpanded={true}
            title={Translations.FormRowColumn}
        >
            <GridRow>
                {props.lineTypeCol && (
                    <>
                        {props.previewType === TaskTypeDialogPreviewType.Web &&
                            <Grid item sm={12}>
                                <FormDesignerComponentPropertiesWidth
                                    classes={props.lineTypeCol?.class}
                                    formFieldMargin={props.formFieldMargin}
                                    sizePrefix={
                                        props.lineTypeCol?.class.includes(TaskTypeClassWidthPrefix.Web2)
                                            ? TaskTypeClassWidthPrefix.Web2
                                            : TaskTypeClassWidthPrefix.Web
                                    }
                                    id={props.lineTypeCol?.field}
                                    minimum={0}
                                    maximum={12 - props.lineColumnWidths.filter(i => i.webWidth > 0).length + 1}
                                    title={Translations.FormColumnWidth}
                                    onUpdate={props.onChangeLineColumnWidth}
                                />
                            </Grid>
                        }
                        {props.previewType === TaskTypeDialogPreviewType.Mobile &&
                            <Grid item sm={12}>
                                <FormDesignerComponentPropertiesWidth
                                    classes={props.lineTypeCol?.class}
                                    formFieldMargin={props.formFieldMargin}
                                    sizePrefix={TaskTypeClassWidthPrefix.Mobile}
                                    id={props.lineTypeCol?.field}
                                    minimum={0}
                                    maximum={12 - props.lineColumnWidths.filter(i => i.mobileWidth > 0).length + 1}
                                    title={Translations.FormColumnWidthMobile}
                                    onUpdate={props.onChangeLineColumnWidth}
                                />
                            </Grid>
                        }
                        {props.previewType === TaskTypeDialogPreviewType.Print &&
                            <Grid item sm={12}>
                                <FormDesignerComponentPropertiesWidth
                                    classes={props.lineTypeCol?.class}
                                    formFieldMargin={props.formFieldMargin}
                                    sizePrefix={TaskTypeClassWidthPrefix.Print}
                                    id={props.lineTypeCol?.field}
                                    minimum={0}
                                    maximum={12 - props.lineColumnWidths.filter(i => i.printWidth > 0).length + 1}
                                    title={Translations.FormColumnWidthPrint}
                                    onUpdate={props.onChangeLineColumnWidth}
                                />
                            </Grid>
                        }
                    </>
                )}
            </GridRow>
        </FormAccordion>
    );
};
